import { get, post, put, del } from './base'

export const getAll = () => get('clients').then(clients => clients || [])
export const getOne = clientId => get(`clients/${clientId}`)

export const create = client => post('clients', client)
export const update = (clientId, client) => put(`clients/${clientId}`, client)
export const remove = clientId => del(`clients/${clientId}`)
